import React from 'react';
import Head from 'next/head';
import _ from 'lodash';

import buildDispensaryJsonLd from './build-dispensary-json-ld';
import buildProductJsonLd from './build-product-json-ld';
import buildCategoryPageJsonLd from './build-category-page-json-ld';
import useStoreFrontAbsoluteUrl from '../use-store-front-absolute-url';

const builders = {
  dispensary: buildDispensaryJsonLd,
  product: buildProductJsonLd,
  categoryPage: buildCategoryPageJsonLd,
};

// Prevent user-authored content containing `</script>` from ending the script element.
const serializeJsonLd = (data) =>
  JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');

const JsonLDScript = ({ variant, jsonLdData }) => {
  const storeFrontAbsoluteUrl = useStoreFrontAbsoluteUrl();
  const buildJsonLd = builders[variant];

  if (!buildJsonLd) {
    console.error(`Unsupported ${variant} variant passed to JsonLDScript`);

    return null;
  }

  if (_.isEmpty(jsonLdData)) {
    console.error(`Empty ${variant} data passed to JsonLDScript`);

    return null;
  }

  return (
    <Head>
      <script
        key={`json-ld-${variant}`}
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(buildJsonLd(jsonLdData, storeFrontAbsoluteUrl)) }}
      />
    </Head>
  );
};

export default JsonLDScript;
